import { render, staticRenderFns } from "./caipin.vue?vue&type=template&id=9f0650ce"
import script from "./caipin.vue?vue&type=script&lang=js"
export * from "./caipin.vue?vue&type=script&lang=js"
import style0 from "./caipin.vue?vue&type=style&index=0&id=9f0650ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports